export default "__VITE_ASSET__1b722e5c__"